export const HotToursTabs = {
  bishkek: {
    title: 'tours_block.from_bishkek',
    key: '2000003268',
  },
  almaty: {
    title: 'tours_block.from_almaty',
    key: '798',
  },
} as const

export const HotToursTabsList = (
  Object.keys(HotToursTabs) as HotToursTabTypes[]
).map((key) => ({
  name: HotToursTabs[key].key,
  title: HotToursTabs[key].title,
}))

export type HotToursTabTypes = keyof typeof HotToursTabs
